function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.3959 8.1L18.25 0.75H16.5L10.6084 7.05L6.00002 0.75H0.166687L7.34169 10.55L0.166687 18.25H1.91669L8.12919 11.6L13 18.25H18.8334L11.3959 8.1ZM2.76252 1.91667H5.09585L16.2084 17.0833H13.875L2.76252 1.91667Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/x.0c86b112.svg";
export { SvgComponent as ReactComponent };